// @flow
import { parseLocation } from 'er2_web_utils'
import { parse, stringify } from 'query-string'
import * as routes from '../constants/routes'
import { processBookmarks } from './bookmarks'
import { getFicusInfo } from './ficus_data'
import * as types from '../constants/action_types'

const setFetchingFrameworks = (isFetching: boolean, exception?: { message: string, traceback: string }) =>
    ({ type: types.SET_FETCHING_FRAMEWORKS, isFetching, exception })

const receiveFrameworks = (nodePath: string, frameworks: Array<{
    text: string,
    children: Array<mixed>,
    collapsed: boolean,
    data: {
        description_path: string,
        has_rasters: boolean,
        is_dir: boolean,
        modes: string[],
        path: string,
    }
}>) => (dispatch: Function, getState: Function) => {
    dispatch({ type: types.RECEIVE_FRAMEWORKS, nodePath, frameworks })

    // Update bookmark status
    const groups = ['bookmarksGlobal', 'bookmarksLocal', 'bookmarksMRU']
    groups.forEach((bookmarkType) => {
        let bookmarks = getState().selectBookmarkBar[bookmarkType]
        bookmarks = processBookmarks(bookmarks, frameworks)
        dispatch({ type: types.ADD_BOOKMARKS, bookmarkType, bookmarks })
    })
}

export const fetchFrameworks = optionsArg => (dispatch: Function, getState: Function) => {
    const options = optionsArg || {}
    const { history, nodePath } = options
    let fetchError = false
    let query = `?token=${getState().token.value}`
    if (nodePath) {
        query += `&nodePath=${nodePath}`
    }
    dispatch(setFetchingFrameworks(true))
    fetch(`/${getState().meta.name}/api/v1/ficus/${query}`).then((response) => {
        fetchError = !response.ok
        if (fetchError) {
            return { exception: { status: response.status, statusText: response.statusText } }
        }
        return response.json()
    }).then((json) => {
        dispatch(setFetchingFrameworks(false))
        if (fetchError) {
            dispatch(setFetchingFrameworks(true, { ...json.state.exception }))
            dispatch(receiveFrameworks(nodePath, []))
        } else {
            dispatch(setFetchingFrameworks(true))
            dispatch(receiveFrameworks(nodePath, json.state.frameworks))
            // If location is home and there is a top-level info node, then load it
            const parsedLoc = parseLocation(location)
            if (parsedLoc.path === routes.HOME) {
                // If the frameworkInfoUrl is filled in, then assume that we have info for the root node. Do
                //   a new request.
                if (history && json.state.ficus_info.frameworkInfoUrl) {
                    dispatch(getFicusInfo(''))
                    history.push({
                        search: stringify({ ...parse(parsedLoc.params), infoNode: '' }),
                        pathname: routes.FRAMEWORK_INFO,
                    })
                }
            }
        }
        if (options.fnFinished) {
            options.fnFinished()
        }
    })
}
